import { render, staticRenderFns } from "./BindsArrowLeftIcon.vue?vue&type=template&id=0f55dbf5&"
import script from "./BindsArrowLeftIcon.vue?vue&type=script&lang=js&"
export * from "./BindsArrowLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports